import React from "react";
import { SonicGameSelectionData } from "../../common/classes/SonicGameSelection";
import { SonicGameDetailData } from "../../common/classes/SonicGameDetail";

type Props = {
  gameName: string;
  selectionData: SonicGameSelectionData;
  detailData: SonicGameDetailData;
};
const GameDetailItem: React.FC<Props> = ({
  gameName,
  selectionData,
  detailData,
}) => {
  const excludeDeletedRank = () => {
    const rank = selectionData.rank.filter((r) => r.id === detailData.rank);

    return rank[0] ? rank[0].value : "";
  };

  const rank = excludeDeletedRank();

  // 管理画面からの削除された項目が登録されていた場合表示しない
  // ゲーム名のみの表示になってしまう場合nullを返す
  if (!rank) {
    return null;
  }

  return (
    <>
      <dd>
        <span>{gameName}</span>
      </dd>
      <dt>
        <span>最高到達ランク</span>
        <span>{rank}</span>
      </dt>
    </>
  );
};

export default GameDetailItem;
